import { PropsWithChildren, useId } from "react"
import { AccordionContent, AccordionItem, AccordionTrigger } from "~/components/reusable/Accordion"
import { cn } from "~/utils/helpers"

type Props = PropsWithChildren & {
  HoverCardRow: React.ReactNode
  isLast?: boolean
  className?: string
  hideCaret?: boolean
  value?: string
}

export default function HoverCardExpandableRow({
  HoverCardRow,
  className,
  hideCaret,
  children,
  value,
}: Props) {
  const generatedId = useId()
  const accordionId = value ?? generatedId
  return (
    <AccordionItem value={accordionId}>
      <AccordionTrigger
        hideCaret={hideCaret}
        className={cn(
          "group/expandable border-none hover:no-underline py-0 justify-between [&>*:first-child]:flex-1",
          hideCaret ? "pr-0" : "pr-4 font-semibold",
          className,
        )}
      >
        {HoverCardRow}
      </AccordionTrigger>
      <AccordionContent className="p-0">{children}</AccordionContent>
    </AccordionItem>
  )
}
